import {graphql} from 'gatsby'
import React from 'react'
import styled from 'styled-components'

import Image from '@/components/image'
import RichText, {hasRichText} from '@/components/rich-text'
import {Text} from '@/components/text'
import {BackgroundWrapper, Container, Layout, Section} from '@/styles/grid'
import mq from '@/utils/media-query'

import type {MagnetHeroSliceFragment} from '@/graphql-types'

export const MagnetHeroSlice = ({
    title,
    description,
    image,
}: MagnetHeroSliceFragment['primary']) => {
    return (
        <WideContainer>
            <Wrapper $color="pink" as={StyledSection} padding="small">
                <Layout $variant="two-equal" $alignItems="center">
                    <Content>
                        {title && (
                            <Text as="h1" $variant="heading-large">
                                {title}
                            </Text>
                        )}

                        {hasRichText(description.richText) && (
                            <StyledDescription
                                $variant="paragraph-large"
                                content={description.richText}
                            />
                        )}
                    </Content>

                    {image && (
                        <ImageWrapper>
                            <Image image={image} />
                        </ImageWrapper>
                    )}
                </Layout>
            </Wrapper>
        </WideContainer>
    )
}

const WideContainer = styled(Container)`
    ${mq.min('xl')} {
        padding-right: ${({theme}) => theme.spacings.s40};
        padding-left: ${({theme}) => theme.spacings.s40};
    }
`

const Wrapper = styled(BackgroundWrapper)`
    border-radius: ${({theme}) => theme.radii.arc20};
`

const StyledSection = styled(Section)`
    padding-bottom: 0;

    ${mq.max('md')} {
        padding-top: ${({theme}) => theme.spacings.s24};
    }

    ${mq.min('md')} {
        padding-right: ${({theme}) => theme.spacings.s40};
        padding-left: ${({theme}) => theme.spacings.s40};
    }
`

const Content = styled.div`
    padding-bottom: ${({theme}) => theme.spacings.s24};

    ${mq.min('md')} {
        padding-bottom: ${({theme}) => theme.spacings.s40};
    }
`

const StyledDescription = styled(RichText)`
    margin-top: ${({theme}) => theme.spacings.s20};

    ${mq.min('lg')} {
        margin-top: ${({theme}) => theme.spacings.s32};
    }
`

const ImageWrapper = styled.div`
    height: 100%;
    display: flex;
    align-items: flex-end;
`

export const magnetHeroSliceFragment = graphql`
    fragment MagnetHeroSlice on PrismicSlicePageDataBodyMagnetHero {
        __typename
        primary {
            title
            description {
                richText
            }
            image {
                alt
                copyright
                url
                dimensions {
                    height
                    width
                }
                gatsbyImageData(breakpoints: $imageBreakpoints, sizes: $twoColumns)
            }
        }
    }
`
